/* eslint no-use-before-define: 0 */

import { request, requestConfig } from '../../../../utils/request.js';

import {
    FETCH_GROUPS, FETCH_GROUPS_SUCCESS, FETCH_GROUPS_FAILURE,
    FETCH_REMOVE_GROUP, FETCH_REMOVE_GROUP_SUCCESS, FETCH_REMOVE_GROUP_FAILURE,
    FETCH_SAVE_GROUP, FETCH_SAVE_GROUP_SUCCESS, FETCH_SAVE_GROUP_FAILURE,
    FETCH_USERS_FOR_GROUP, FETCH_USERS_FOR_GROUP_SUCCESS, FETCH_USERS_FOR_GROUP_FAILURE,
    CLEAR_GROUP, EMPTY_GROUPS, SET_GROUP, UPDATE_FILTER_BY, UPDATE_GROUPS, UPDATE_SEARCH_TERM, UPDATE_SORT_BY, UPDATE_THUMBNAIL_TO_UPLOAD
} from './constants';

import { PATHS } from '../../../../utils/paths';

/**
 * Sync Action Creators
 */
export const clearGroup = () => ({
    type: CLEAR_GROUP
});

export const emptyGroups = () => ({
    type: EMPTY_GROUPS
});

const fetchGroups = () => ({
    type: FETCH_GROUPS
});

const fetchGroupsSuccess = (data) => ({
    type: FETCH_GROUPS_SUCCESS,
    data
});

const fetchGroupsFailure = (error) => ({
    type: FETCH_GROUPS_FAILURE,
    error
});

const fetchRemoveGroup = () => ({
    type: FETCH_REMOVE_GROUP
});

const fetchRemoveGroupSuccess = () => ({
    type: FETCH_REMOVE_GROUP_SUCCESS
});

const fetchRemoveGroupFailure = (error) => ({
    type: FETCH_REMOVE_GROUP_FAILURE,
    error
});

const fetchSaveGroup = () => ({
    type: FETCH_SAVE_GROUP
});

const fetchSaveGroupSuccess = (data) => ({
    type: FETCH_SAVE_GROUP_SUCCESS,
    data
});

const fetchSaveGroupFailure = (error) => ({
    type: FETCH_SAVE_GROUP_FAILURE,
    error
});

const fetchUsersForGroup = () => ({
    type: FETCH_USERS_FOR_GROUP
});

const fetchUsersForGroupSuccess = () => ({
    type: FETCH_USERS_FOR_GROUP_SUCCESS
});

const fetchUsersForGroupFailure = (error) => ({
    type: FETCH_USERS_FOR_GROUP_FAILURE,
    error
});

export const setGroup = (data) => ({
    type: SET_GROUP,
    data
});

export const updateFilterBy = (data) => ({
    type: UPDATE_FILTER_BY,
    data
});

export const updateSearchTerm = (data) => ({
    type: UPDATE_SEARCH_TERM,
    data
});

export const updateSortBy = (data) => ({
    type: UPDATE_SORT_BY,
    data
});

export const updateThumbnailToUpload = (data) => ({
    type: UPDATE_THUMBNAIL_TO_UPLOAD,
    data
});

export const updateGroups = (data) => ({
    type: UPDATE_GROUPS,
    data
});



/**
 * Async Action Creators
 */
export const deleteGroup = (callback) => (dispatch, getState) => {
    dispatch(fetchRemoveGroup());
    let group = getState().groups.group;
    request(PATHS.groups.putGroup(group.id), requestConfig('DELETE'))
        .then(() => {
            dispatch(fetchRemoveGroupSuccess());
            // Loop through all existing groups to see if this user exists. If so, remove it
            let groups = getState().groups.allGroups;
            for(var i = 0, l = groups.length; i < l; i++) {
                if(groups[i].id === group.id) {
                    groups.splice(i, 1);
                    break;
                }

            }
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(fetchRemoveGroupFailure(error));
        })
};

export const getGroups = (callback) => (dispatch, getState) => {
    dispatch(fetchGroups());
    let groupsStore = getState().groups;
    let path = '';
    let pageNumber = groupsStore.pageNumber + 1;

    if(groupsStore.searchTerm !== '') {
        path = PATHS.groups.getGroups.search(groupsStore.searchTerm, pageNumber, groupsStore.pageSize);
    } else {
        let userId = getState().auth.user.id;
        path = PATHS.groups.getGroups.filtered(groupsStore.filterBy, groupsStore.sortBy, groupsStore.sortDirection, pageNumber, groupsStore.pageSize, userId);
    }

    request(path, requestConfig('GET'))
        .then((data) => {
            dispatch(fetchGroupsSuccess(data));
            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(fetchGroupsFailure(error));
        });
};

export const getUsersAndSetGroup = (group) => (dispatch) => {
    dispatch(setGroup(group));
    dispatch(fetchUsersForGroup());

    let assignmentsCompletedCount = 0;
    let usersCompletedCount = 0;
    let users = [];
    let assignments = [];
    group.userIds.forEach((id) => {
        request(PATHS.users.getUser.byID(id, false), requestConfig('GET'))
            .then((user) => {
                usersCompletedCount++;
                users.push(user);
                if(usersCompletedCount === group.userIds.length) {
                    group.users = users;
                    if(assignmentsCompletedCount + usersCompletedCount === group.userIds.length + group.assignmentIds.length) {
                        dispatch(setGroup(group));
                        dispatch(fetchUsersForGroupSuccess());
                    }
                }
            })
            .catch((error) => {
                console.log('error getting users for group', error);
                dispatch(fetchUsersForGroupFailure(error));
            })
    });

    group.assignmentIds.forEach((id) => {
        request(PATHS.assignments.getAssignment(id), requestConfig('GET'))
            .then((assignment) => {
                assignmentsCompletedCount++;
                assignments.push(assignment);
                if(assignmentsCompletedCount === group.assignmentIds.length) {
                    group.assignments = assignments;
                    if(assignmentsCompletedCount + usersCompletedCount === group.userIds.length + group.assignmentIds.length) {
                        dispatch(setGroup(group));
                        dispatch(fetchUsersForGroupSuccess());
                    }
                }
            })
            .catch((error) => {
                console.log('error getting assignments for group', error);
                dispatch(fetchUsersForGroupFailure(error));
            });
    });
};

export const postGroupAvatar = (callback) => (dispatch, getState) => {
    dispatch(fetchSaveGroup());

    let file = getState().groups.thumbnailToUpload;

    let xhr = new XMLHttpRequest();
    let formData = new FormData();
    formData.append('file', file);

    xhr.open("POST", PATHS.upload.thumbnail(), true);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', 'application/json');

    // Get the thumbnail elements.
    // TODO: This will need to be boilerplated somehow
    let progressBarEl = document.getElementById('thumbnailProgress'),
        progressBarWrapperEl = document.querySelector('.thumbnail-drop__progress--outer'),
        progressOverlayEl = document.querySelector('.thumbnail-drop__progress--overlay'),
        progressDoneEl = document.querySelector('.thumbnail-drop__progress--done');

    xhr.upload.onprogress = function (event) {
        if (event.lengthComputable) {
            var progress = Math.floor((event.loaded / event.total) * 100);
            //console.log('progress = ' + progress);
            if(progressBarEl != null) {
                progressBarEl.style.width = progress + '%';
            }
        }
    };
    xhr.upload.onloadstart = function (event) {
        if(progressBarEl != null && progressOverlayEl != null && progressBarWrapperEl != null) {
            progressBarEl.style.width = '0%';
            progressOverlayEl.style.display = 'block';
            progressBarWrapperEl.style.display = 'block';
        }
    };
    xhr.upload.onloadend = function (event) {
        //console.log('progress = 100% done');
        if(progressBarWrapperEl != null && progressDoneEl != null && progressOverlayEl != null) {
            setTimeout(function () {
                progressBarWrapperEl.style.display = 'none';
                progressDoneEl.style.display = 'block';
            }, 250);
            setTimeout(function () {
                progressOverlayEl.style.display = 'none';
                progressDoneEl.style.display = 'none';
            }, 750);
        }
    };
    xhr.onreadystatechange = function() {
        if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
            let group = getState().groups.group;
            group.thumbnail = JSON.parse(xhr.responseText);
            dispatch(setGroup(group));
            dispatch(postPutGroup(callback));
        }
    };
    xhr.send(formData);
};

export const postPutGroup = (callback) => (dispatch, getState) => {
    dispatch(fetchSaveGroup());
    let group = getState().groups.group;
    let method = 'POST';
    let path = PATHS.groups.postGroup();

    if(group.id != null) {
        method = 'PUT';
        path = PATHS.groups.putGroup(group.id);
    }

    request(path, requestConfig(method, group))
        .then((newGroup) => {
            if(newGroup.assignmentIds == null) {
                newGroup.assignmentIds = [];
            }
            dispatch(fetchSaveGroupSuccess(newGroup));

            if(method === 'PUT' && getState().groups.sortBy !== 'modified') { // I'm intentionally excluding modified here, because the group will go at the top, if they are not already
                // Loop through all existing groups to see if this group exists. If so, replace it in the array
                let groups = getState().groups.allGroups;
                for(var i = 0, l = groups.length; i < l; i++) {
                    if(groups[i].id === newGroup.id) {
                        groups[i] = newGroup;
                        break;
                    }
                }
            } else {
                //If it's a new group, then get all groups again
                let groups = getState().groups;
                groups.pageNumber = 0;
                groups.hasMore = true;
                groups.allGroups = [];
                dispatch(updateGroups(groups));
                dispatch(getGroups());
            }

            if(callback) {
                callback();
            }
        })
        .catch((error) => {
            dispatch(fetchSaveGroupFailure(error));
        })
};



// WEBPACK FOOTER //
// ./src/containers/UsersPage/store/groups/actions.js